import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllBlog = async (params: any) => {
  const url = endpoints.BLOG;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const getBlogById = async (id: number) => {
  const url = endpoints.BLOG + "/" + id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createBlog = async (params: any) => {
  const url = endpoints.BLOG;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateBlog = async (params: any) => {
  const url = endpoints.BLOG + "/" + params.get('id');
  const { data: response } = await axios.put(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteBlog = async (id: number) => {
  const url = endpoints.BLOG + "/" + id;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const blogService = {
  getAllBlog,
  createBlog,
  updateBlog,
  deleteBlog,
  getBlogById,
};

export default blogService;
